<template>
  <f7-page no-toolbar no-swipeback name="funds-records" class="page-funds-records" infinite :infinite-distance="50"
    :infinite-preloader="showPreloader" @infinite="loadMore">
    <f7-block class="block-records" v-if="fundsRecordsList.length > 0">
      <!-- <div class="topbtn" @click="releaseToInvestmentAccount()">{{ $t('funds_records_00077') }}</div> -->
      <div class="card card-outline" v-for="item in fundsRecordsList" :key="item.Id">
        <div class="card-header">
          <div class="row no-gap">
            <i class="f7-icons">equal_square</i>
            <div class="col-90 co-white text-left ss">{{ item.TicketNo }}</div>
          </div>
        </div>
        <div class="card-content card-content-padding">
          <div class="row no-gap">
            <div class="col-50 text-left co-white ss">{{ $t('funds_records_0014') }}:</div>
            <div class="col-50 text-right" :class="item.Amount < 0 ? 'co-yellow' : 'co-blue'">{{ item.Amount | formatCurrency }}</div>
          </div>
          <div class="row no-gap">
            <div class="col-50 text-left co-white ss">{{ $t('funds_records_0015') }}:</div>
            <div class="col-50 text-right" :class="item.Amount < 0 ? 'co-yellow' : 'co-blue'">{{ item.Amount_InvestmentAccount | formatCurrency }}</div>
          </div>
          <!-- <div class="row no-gap">
            <div class="col-25 text-left co-white ss">{{ $t('funds_records_0004') }}:</div>
            <div class="col-75 co-green">{{item.Balance| formatCurrency}}</div>
          </div> -->
          <div class="row no-gap">
            <div class="col-25 text-left co-white ss">{{ $t('integral_records_0003') }}:</div>
            <div v-if="item.SubType === 'FinancialProductsCommission'" class="col-75 text-right co-gray">{{ $t('funds_search_0017') }}</div>
            <div v-else-if="item.Type === 'TurnOut'" class="col-75 text-right co-gray">{{ $t('funds_search_0013') }}</div>
            <div v-else-if="item.Type === 'Commission'" class="col-75 text-right co-gray">{{ $t('funds_search_0013') }}</div>
            <div v-else-if="item.Type === 'TurnIn'" class="col-75 text-right co-gray">{{ $t('funds_search_0005') }}</div>
            <div v-else-if="item.Type === 'Deposit'" class="col-75 text-right co-gray">{{ $t('funds_search_0002') }}</div>
            <div v-else-if="item.Type === 'Withdra'" class="col-75 text-right co-gray">{{ $t('funds_search_0003') }}</div>
            <div v-else-if="item.Type === 'WithdraBack'" class="col-75 text-right co-gray">{{ $t('funds_search_0010') }}</div>
            <div v-else-if="item.Type === 'Bonus'" class="col-75 text-right co-gray">{{ $t('funds_search_0008') }}</div>
            <div v-else-if="item.Type === 'Rebate'" class="col-75 text-right co-gray">{{ $t('funds_search_0007') }}</div>
            <div v-else-if="item.Type === 'Chargeback'" class="col-75 text-right co-gray">{{ $t('funds_search_0011') }}</div>
            <div v-else-if="item.Type === 'ManualDeductBonus'" class="col-75 text-right co-gray">{{ $t('funds_search_0014') }}</div>
            <div v-else-if="item.Type === 'LockAmount'" class="col-75 text-right co-gray">{{ $t('funds_search_0014') }}</div>
            <div v-else-if="item.Type === 'UnLockAmount'" class="col-75 text-right co-gray">{{ $t('funds_search_0014') }}</div>
            <div v-else class="col-75 text-right co-gray">{{ item.Type ? item.Type : '--' }}</div>

          </div>
          <div class="row no-gap">
            <div class="col-25 text-left co-white ss">{{ $t('funds_records_0006') }}:</div>
            <div
              v-if="item.Type === 'TurnOut' || item.Type === 'Commission' || item.Type === 'TurnIn' || item.Type === 'Bonus' || item.Type === 'Deposit'"
              class="col-75 text-right co-gray">{{ item.Remark ? item.Remark : '--' }}</div>
            <div v-else class="col-75 co-gray">--</div>
          </div>
          <!-- <div class="row no-gap">
            <div class="col-25 text-left co-white ss">{{ $t('member_center_0058') }}:</div>
            <div class="col-75" v-if="item.ShowReleaseTS">{{ item.ReleaseTS | time }}</div>
            <div class="col-75" v-else>- -</div>
          </div> -->
        </div>
        <div class="card-footer co-white">{{item.CreateTS|time}}</div>
      </div>
    </f7-block>
    <f7-card v-else-if="fundsRecordsList.length <= 0 && !showData" class="no-data">
      <img :src="`../../../static/images/yt999/noData_${$f7.params.currLang}.png`" width="45%"
        :onerror="`this.onerror=''; src='../../../static/images/yt999/noData_enUS.png'`" alt="No data">
    </f7-card>
  </f7-page>
</template>

<script>
// import { getCookie } from '@/config/utils';
import { usernamefundsdetailsdelayedpendingget,releaseToInvestmentAccount } from "../../axios/api";
export default {
  components: {},
  props: { 
    message: {
      type: Number,
      required: true, // 必填
    }
  },
  data() {
    return {
      fundsRecordsList: [],
      allowInfinite: true,
      showPreloader: true,
      pageNow: 1,
      pageTotal: 0,
      showData: true,
    };
  },
  watch: {
    message(newValue) {
      this.fundsRecordsListEvent();
    }
  },
  computed: {},
  methods: {
    fundsRecordsListEvent() {
      const self = this;
      const params = { data: JSON.stringify({ "PageNow": 1, "PageSize": 100 }) };
      this.fundsRecordsList = [];
      usernamefundsdetailsdelayedpendingget(params).then(data => {
        if (data.Code === "NoError") {
          self.fundsRecordsList = self.fundsRecordsList.concat(data.Data[0]);
          self.showData = self.fundsRecordsList.length > 0;
          self.pageTotal = data.Data[1];
          if (self.fundsRecordsList.length >= self.pageTotal) {
            self.showPreloader = false;
          }
        }
      });
    },

    releaseToInvestmentAccount() {
      const self = this;
      self.$f7.$(".dialog-backdrop").css("background", "rgba(0, 4, 7, 0.77)");
      self.$f7.dialog.create({
        title: this.$t("common_0004"),
        text: `<div>` + self.$t("funds_records_0008") + `<br/><span style="color: blue;">` + self.$t("funds_records_0009") + `</span><br/>` + self.$t("funds_records_0010") + `</div>`,
        cssClass: "dialog-logout",
        buttons: [
          {
            text: this.$t("common_0002"),
            cssClass: "dialog-ok",
            onClick: () => {
              self.$f7.sheet.close();
              self.$f7.$(".dialog-backdrop").css("background", "transparent");
            },
          },
          {
            text: this.$t("common_0001"),
            cssClass: "dialog-ok",
            onClick: () => {
              self.$f7.sheet.close();
              self.$f7.$(".dialog-backdrop").css("background", "transparent");
              releaseToInvestmentAccount().then(data => {
                if (data.Code === "NoError") {
                  self.$f7.$(".dialog-backdrop").css("background", "rgba(0, 4, 7, 0.77)");
                  self.$f7.dialog.create({
                    title: this.$t("common_0004"),
                    text: `<div>` + self.$t("funds_records_0011") + `<br/><span style="color: blue;">` + self.$t("funds_records_0012") + `</span><br/>` + self.$t("funds_records_0013") + `</div>`,
                    cssClass: "dialog-logout",
                    buttons: [
                      {
                        text: this.$t("common_0001"),
                        cssClass: "dialog-ok",
                        onClick: () => {
                          self.$f7.sheet.close();
                          self.$f7.$(".dialog-backdrop").css("background", "transparent");
                          
                        },
                      },
                    ],
                  }).open();
                  
                }else{
                  self.$f7.dialog.alert(data.Data, self.$t("common_0004"));
                }
              });
            },
          },
        ],
      }).open();

    },
    loadMore() {
      const self = this;
      if (!self.allowInfinite) return;
      self.allowInfinite = false;

      setTimeout(() => {
        if (self.fundsRecordsList.length >= self.pageTotal) {
          self.showPreloader = false;
          return;
        }
        self.pageNow += 1;
        self.fundsRecordsListEvent();
        self.allowInfinite = true;
      }, 1000);
    }
  },
  created() {
    // this.fundsRecordsListEvent();
  },
  mounted() { }
};
</script>
<style lang="less" scoped>
// ::v-deep .page-content {
//   height: 95vh;
// }

.page-funds-records {
  .ss {
    font-weight: bold;
    // width: 100%;
    // padding-left: 20px;
  }

  .block-records {
    margin: 0;
    padding: 0;
    .topbtn{
      background: var(--f7-THEME-color);
      color: white;
      border-radius: 5px;
      text-align: center;
      margin: 10px;
      padding: 7px 0;
    }
    .card {
      border: 1px solid #d2d2d2;
      background-color: #f9f9f9;
      margin: 8px;

      .co-white {
        color: #464646;
        word-wrap: break-word;
      }

      .co-gray {
        color: #474753;
        word-wrap: break-word;
      }

      .co-green {
        color: #17903a;
      }

      .co-blue {
        color: #028cb3;
      }

      .co-yellow {
        color: #f79400;
      }

      .co-red {
        color: #c50d0d;
      }

      .card-header:after,
      .card-footer:before {
        background-color: #e3e3e3;
        height: 2px;
      }

      .card-header {
        display: block;
        font-size: 12px;
        padding: 10px 15px 10px 8px;
        min-height: auto;
        div{
        align-items: center;
        }
        i.f7-icons {
          font-size: 18px;
          vertical-align: middle;
          margin-top: 1px;
          //color: #1e56bb;
        }
      }

      .card-content {
        font-size: 12px;
        padding: 2px 10px;

        .row {
          padding: 4px 0;
        }
      }

      .card-footer {
        justify-content: flex-end;
        padding: 8px 15px;
      }
    }
  }

  .no-data {
    background-color: transparent;
    box-shadow: none;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    min-height: 200px;
  }
}
</style>